<template>
  <div v-if="createdAt || updatedAt"
       class="small text-muted mb-3">
    <div class="created-at" v-if="createdAt">* {{ $t('creation_date') }}: {{ formatDateTime(createdAt) }}</div>
    <div class="created-at" v-if="updatedAt">* {{ $t('last_update') }}: {{ formatDateTime(updatedAt) }}</div>
  </div>
</template>

<script setup>
import {computed} from "vue"
import { formatDateTime} from "@/extensions/filters/filters"

const props = defineProps({
  object: {}
})

const createdAt = computed(() => props.object?.id && props.object?.created_at)
const updatedAt = computed(() => props.object?.id && props.object?.updated_at)
</script>
